// extracted by css-extract-rspack-plugin
export default {"imgContainer":"Cz4aw7oa","loaderContainer":"EQCOI7d3"};